import { DateUtils } from '../DateUtils';

export const CurrentSearchToReduxStoreValues = (currentSearch) => {
    const { destination, dates, rooms } = currentSearch;

    const segments = [
        {
            id: Date.now(), // Generate a unique id
            showErrors: false,
            destination: destination,
            date: DateUtils.parse(dates.checkin)
        },
        {
            id: Date.now() + 1, // Generate a unique id
            showErrors: false,
            date: DateUtils.parse(dates.checkout)
        }
    ];

    const transformedRooms = rooms.map((room) => ({
        id: room.id,
        adults: room.adults,
        kids: room.kids,
        showKidError: false
    }));

    return {
        segments,
        rooms: transformedRooms
    };
};
